


export function register(Vue){

    Vue.component('messaging', require('../components/partials/Messaging'))
    Vue.component('mobile-scroll-up', require('../components/layouts/MobileScrollUp'))
    Vue.component('ffooter', require('../components/footer/Ffooter'))
    Vue.component('layouts-header', require('../components/layouts/LayoutsHeader'))
    Vue.component('loading-spinner', require('../components/partials/LoadingSpinner'))
    Vue.component('select-box', require('../components/partials/SelectBox.vue'))
    Vue.component('custom-select', require('../components/partials/CustomSelect'))
    Vue.component('custom-input', require('../components/partials/CustomInput'))
    Vue.component('currency-field', require('../components/footer/CurrencyField'))
    Vue.component('inline-loader', require('../components/partials/InlineLoader'))
}


// WEBPACK FOOTER //
// ./resources/js/mixins/registry.js